import cn from 'classnames';
import React from 'react';
import AspectRatio, { AspectRatioBasis } from 'components/AspectRatio';
import PodcastArtwork from 'components/PodcastArtwork';
import { useWidget } from 'state/widget/context';

import { ImageResizeStrategy } from 'types';
import styles from './Artwork.module.scss';

export interface ArtworkProps {
  aspectRatio?: number;
  aspectRatioBasis?: AspectRatioBasis;
  resize?: ImageResizeStrategy;
}

const Artwork: React.FC<ArtworkProps> = ({
  aspectRatio = 1,
  aspectRatioBasis,
  resize,
}) => {
  const {
    state: { aspectRatioHeight, aspectRatioWidth, imageResizeStrategy },
  } = useWidget();

  const aspectRatioFromConfig =
    aspectRatioWidth && aspectRatioHeight
      ? aspectRatioHeight / aspectRatioWidth
      : undefined;

  return (
    <AspectRatio
      className={styles.frame}
      basis={aspectRatioBasis}
      ratio={aspectRatioFromConfig ?? aspectRatio}
    >
      <PodcastArtwork
        className={cn(styles.artwork, {
          [styles[`artwork__${imageResizeStrategy ?? resize}`]]: true,
        })}
      />
    </AspectRatio>
  );
};

export default Artwork;
